import { Toaster } from '@lms/ui/toaster';
import { TooltipProvider } from '@lms/ui/tooltip';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { LocaleProvider } from '@/i18n/locale-provider';
import { App } from './App';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('root element missing');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <LocaleProvider>
        <TooltipProvider delayDuration={200}>
          <App />
          <Toaster />
        </TooltipProvider>
      </LocaleProvider>
    </BrowserRouter>
  </StrictMode>,
);
